import React from "react";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useLazyGetDashboardReportQuery } from "../../../../toolkit/dashboardReport/dashboardReportApi";
import { getCommaFormattedNumber } from "../../../../utils/methods/stringMethods";

const StatCard = ({ title, value, background }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: background || "#1A1A1A",
        borderRadius: "0.5rem",
        paddingTop: "1.5rem",
        paddingBottom: "1.5rem",
        paddingLeft: "2rem",
        paddingRight: "2rem",
        flex: 1,
        minWidth: "10rem",
      }}
    >
      <Typography
        sx={{
          color: theme.palette.text.secondary,
          fontSize: "1rem",
          fontWeight: 400,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          color: theme.palette.text.secondary,
          fontSize: "1.5rem",
          fontWeight: 600,
          marginTop: "0.5rem",
        }}
      >
        {getCommaFormattedNumber(value)}
      </Typography>
    </Box>
  );
};

const DashboardStatsDetail = () => {
  const { t } = useTranslation("dashboard");
  const theme = useTheme();

  const [getDashboardReportApiHandler, getDashboardReportApiData] = useLazyGetDashboardReportQuery();

  // useEffect start...
  React.useEffect(() => {
    (async () => {
      await getDashboardReportApiHandler({});
    })();
  }, []);
  // useEffect end...

  console.log(`getDashboardReportApiData`, getDashboardReportApiData)

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "1rem",
        backgroundColor: theme.palette.background.default,
        paddingTop: "2rem",
        paddingBottom: "2rem",
        paddingLeft: "2rem",
        paddingRight: "2rem",
        borderRadius: "1rem",
      }}
    >
      {getDashboardReportApiData?.isFetching ? (
        <Box
          sx={{
            width: "100%",
            height: "100%"
          }}
        >
          <CircularProgress 
            size={22}
          />
        </Box>
      ) : (
        <>
          {/* Translation applied to StatCard titles */}
          <StatCard 
            title={t("Sold Cars")} 
            value={getDashboardReportApiData?.data?.data?.sold_cars_count} 
            background={theme.palette.primary.main} 
          />
          <StatCard 
            title={t("Purchase cars")} 
            value={getDashboardReportApiData?.data?.data?.purchase_cars_count} 
          />
          <StatCard 
            title={t("Sold Amount")} 
            value={getDashboardReportApiData?.data?.data?.sold_cars_amount} 
          />
          <StatCard 
            title={t("Purchase Amount")} 
            value={getDashboardReportApiData?.data?.data?.purchase_cars_amount} 
          />
        </>
      )}
    </Box>
  );
};

export default DashboardStatsDetail;